<template>
    <div class="payment-type-icon">
        <img v-if="paymentType === PaymentTypes.BOLETO" src="@/assets/img/payment-types/boleto.svg" alt="Boleto" />
        <img v-if="paymentType === PaymentTypes.QRCODE" src="@/assets/img/payment-types/qrcodepay.png" alt="QR Code" />
        <img v-if="paymentType === PaymentTypes.PIX" src="@/assets/img/payment-types/pix.svg" alt="Pix" />
        <img v-if="paymentType === PaymentTypes.QRCODE_DEBIT" src="@/assets/img/payment-types/qrcodepay.png" alt="QR Code" />
        <img v-if="paymentType === PaymentTypes.PIX_OPEN_FINANCE" src="@/assets/img/payment-types/pix-open-finance.svg" alt="Pix Open Finance" />
    </div>
</template>

<script>
    import PaymentTypes from '@/models/PaymentTypes';

    export default {
        props: {
            paymentType: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                PaymentTypes
            };
        }
    };
</script>

<style lang="scss" scoped>
    .payment-type-icon {
        img {
            width: 40px;
            height: 24px;
        }
    }
</style>
